import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=820d195a&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SearchResults.vue?vue&type=style&index=0&id=820d195a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SearchResults.vue?vue&type=style&index=1&id=820d195a&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "820d195a",
  "6f904166"
  
)

export default component.exports